import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { useContent } from "@/lib/content";
import { Media, SmartLink } from "./Media";
import { BookLink } from "@/lib/fresha";

const fade = (d) => ({ initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.7, delay: d } });

export const Hero = () => {
  const h = useContent().data.hero;
  return (
    <>
      <section className="hero" data-testid="hero-section">
        <div className="hero-copy">
          <motion.p className="eyebrow" {...fade(0.05)}>{h.eyebrow}</motion.p>
          <motion.h1 {...fade(0.15)} data-testid="hero-title">{h.title_line1}<br /><em>{h.title_line2}</em></motion.h1>
          <motion.p className="lead" {...fade(0.25)}>{h.lead}</motion.p>
          <motion.div className="actions" {...fade(0.35)}>
            <BookLink className="btn gold" testId="hero-book-button">Book an appointment <ArrowUpRight size={14} /></BookLink>
            <a className="btn light" href="#services" data-testid="hero-explore-button">Explore treatments</a>
          </motion.div>
        </div>
        <div className="hero-photo">
          <Media src={h.image} w={800} sizes="(min-width: 850px) 50vw, 100vw" alt="Calm luxury spa treatment room" priority testId="hero-media" />
          <div className="photo-label">{h.photo_label}
            {h.media_link_label && <SmartLink to={h.media_link_url} className="media-cta" testId="hero-media-link">{h.media_link_label} <ArrowUpRight size={13} /></SmartLink>}
          </div>
        </div>
      </section>
      <div className="features" data-testid="feature-strip">
        {h.features.map((t) => (
          <div key={t}><Sparkles size={12} /> {t}</div>
        ))}
      </div>
    </>
  );
};
